import { TaxDetailsHeader } from '@dealstack/frontend/shared/components/SingleTaxDetails/TaxDetailsHeader.tsx';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { GetPersonTaxInformationRes } from '@dealstack/shared/lib/generated';
import { Button, Divider, Flex } from '@mantine/core';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';

import { TaxResidenceEntryFields } from './TaxResidenceEntryFields';
import { createEmptyTaxResidence, TAX_RESIDENCES_FIELD } from './taxResidences.utils';
import { TaxResidencesFormValues } from './useJoinAndAllocationOtherDetails.types';

interface Props {
	showTin: boolean;
	savedTaxResidences: GetPersonTaxInformationRes[];
}

export const TaxResidencesSection = ({ showTin, savedTaxResidences }: Props) => {
	const tInvestor = useTranslationInvestor();
	const { control } = useFormContext<TaxResidencesFormValues>();

	const { fields, append, remove } = useFieldArray({
		control,
		name: TAX_RESIDENCES_FIELD,
	});

	const watchedEntries = useWatch({ control, name: TAX_RESIDENCES_FIELD }) ?? [];

	return (
		<Flex direction="column" gap="1rem">
			<TaxDetailsHeader />

			{fields.map((field, index) => {
				const saved = savedTaxResidences.find(
					(tax) => tax.id === watchedEntries[index]?.taxId
				);

				return (
					<TaxResidenceEntryFields
						key={field.id}
						index={index}
						showTin={showTin}
						disabled={!showTin && !!saved}
						initialTaxResidency={saved?.countryCode}
						initialTin={saved?.number ?? undefined}
						onRemove={fields.length > 1 ? () => remove(index) : undefined}
					/>
				);
			})}

			<div>
				<Button
					variant="default"
					onClick={() => append(createEmptyTaxResidence(), { shouldFocus: false })}
				>
					{tInvestor('investment.personal_details.tax_residences.add', {
						defaultValue: 'Add tax residence',
					})}
				</Button>
			</div>

			<Divider mt="1rem" />
		</Flex>
	);
};
